import React, {useEffect, useState} from "react";
import {Col} from "antd";
import moment from "moment";
import {
    DateFilter,
    SubCompanyWorkTypeFilter,
    PoolFilter,
    SearchText,
    CityFilter
} from "../../_defaultComponents/FilterComponents";
import {useStore} from "../../../hooks/useStore";
import {useObserver} from "mobx-react-lite";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import PoolShiftEntryModal from "./PoolShiftEntryModal/PoolShiftEntryModal";
import PoolShiftStatusFilter from "../../_defaultComponents/FilterComponents/PoolShiftStatusFilter";

const PoolShiftManagementFilters = ({
    setCurrentPage,
    poolFilters,
    setPoolFilters,
    setWorkType,
    workType,
    setReloadData,
    status,
    setStatus
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [date, setDate] = useState(moment(poolFilters.date));
    const [searchText, setSearchText] = useState(poolFilters.searchText);
    const [pool, setPool] = useState(poolFilters.pool || "all");
    const [city, setCity] = useState(poolFilters.city || "all");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [poolData, setPoolData] = useState([]);
    const showModal = async () => {
        setIsModalOpen(true);
        const poolData = await stores.poolStore.getUserPools({});
        setPoolData(poolData);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [date]);

    useEffect(() => {
        const newFilters = {
            ...poolFilters,
            date,
            searchText,
            pool,
            city
        };

        if (JSON.stringify(poolFilters) !== JSON.stringify(newFilters)) {
            setPoolFilters(newFilters);
        }
    }, [date, workType, searchText, pool, city]);

    return useObserver(() => (
        <React.Fragment>
            <PoolShiftEntryModal
                visible={isModalOpen}
                onCancel={handleCancel}
                setIsModalOpen={setIsModalOpen}
                setReloadData={setReloadData}
                poolData={poolData}
            />
            <Col xs={24} sm={12} md={6} lg={4} xl={3}>
                <SubCompanyWorkTypeFilter
                    showAllOption={false}
                    value={workType}
                    onChange={value => {
                        setWorkType(value);
                        setCurrentPage(1);
                    }}
                />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <CityFilter value={city} onChange={setCity} />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <PoolFilter value={pool} onChange={setPool} label="Vardiya Adı" city={city} />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={5}>
                <PoolShiftStatusFilter value={status} onChange={setStatus} />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <SearchText value={searchText} onChange={setSearchText} />
            </Col>

            <Col xs={48} sm={40} md={32} lg={20} xl={16}>
                <DateFilter value={date} onChange={setDate} />

                <CustomButton
                    onClick={() => showModal()}
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{marginLeft: 10}}
                >
                    {t("actions.addShift", {
                        ns: "common"
                    })}
                </CustomButton>
            </Col>
        </React.Fragment>
    ));
};

export default PoolShiftManagementFilters;
